export default __webpack_public_path__ + "static/media/location_dark.0531cb61.svg";